import React, {useState, useEffect} from 'react'
import { reduxForm, Field, getFormValues, formValueSelector, change } from "redux-form";
import { connect } from "react-redux";
import axios from 'axios';
import { store } from "../_helpers";
import InputField from "../_common/InputField";
import TextareaField from "../_common/TextareaField";
import SearchBox from "./SearchBox";
import SelectSimple from "../_common/SelectSimple";
import FinalSelect from "../_common/FinalSelect";
import SelectSimpleParser from "../_common/SelectSimpleParser";
import SelectDynamic from "../_common/SelectSimple";
import CheckBoxSimple from "../_common/CheckBoxSimple";
import GoogleMapReact from 'google-map-react';
import {Popover, Button, Table, Divider, Tag, Icon, notification } from 'antd';
import {
  Row,
  Col,
  Card,
  FormInput,
  Button as BTX,
  Modal,
  ModalHeader,
  ModalBody,
  CardBody,
} from "shards-react";
import Cookies from "universal-cookie";
import { CrearServicio } from './CrearServicio';
import { EditarServicio } from './EditarServicio';
import { API_URL } from "../_config";
import ModalUrlEdit from './ModalUrlEdit/ModalUrlEdit';
const cookies = new Cookies();

var provincia = undefined;


const SomePoint = ({ text }) => <div>{text}</div>;

const SideX = props => {
    const [provincias, setProvincias] = useState([]);
    const [partidos, setPartido] = useState([]);
    const [barrios, setBarrio] = useState([]);
    const [whatsapp, setWhatsApp] = useState(props.activedX.whatsapp);


    const [mapsApiLoaded, setMapsApiLoaded] = useState(false);
    const [mapInstance, setMapInstance] = useState(null);
    const [mapsapi, setMapsApi] = useState(null);     
    const [latitud, setLatitud] = useState(props.activedX.latitude ? props.activedX.latitude : -34.596066);
    const [longitud, setLongitud] = useState(props.activedX.longitude ? props.activedX.longitude : -58.411741);
    const [first, setFirst] = useState(false);
    const [openServicio, setOpenServicio] = useState(false);

    const [editar_data, seteditar_data] = useState([]);
    const [openServicioEditar, setOpenServicioEditar] = useState(false);
    const [openModalUrlEditState, setModalUrlEditState] = useState(false);

    useEffect(() => {
      props.activedX.latitude = latitud;
    }, [latitud])

    useEffect(() => {
      props.activedX.longitude = longitud;
    }, [longitud])
    


    useEffect(() => {

        if(first == false) {
          props.activedX.latitude = latitud;
          props.activedX.longitude = longitud;
          setFirst(true);
        }
      
        axios({
            method: "get",
            url:
              API_URL + "api/region?token=" +
              store.getState().authentication.user.token
          }).then(response => {
            setProvincias(response.data);
          });
 
          axios({
            method: "get",
            url:
              API_URL + "api/region-city/" + props.activedX.region_id
          }).then(response => {
            setPartido(response.data);
          }); 

          axios({
            method: "get",
            url:
              API_URL + "api/region-state-city/" + props.activedX.region_city_id
          }).then(response => {
            setBarrio(response.data);
          });
    
  }, [props.activedX]);

    const apiHasLoaded = (map, googlemaps) => {
      if (map && googlemaps) { 
        setMapsApiLoaded(true);
        setMapInstance(map);
        setMapsApi(googlemaps);
    }
  }
    const call_partido = val => {
        axios({
            method: "get",
            url:
              API_URL + "api/region-city/" + val
          }).then(response => {
            setPartido(response.data);
          });
    }
    const call_barrio = val => {
        axios({
            method: "get",
            url:
              API_URL + "api/region-state-city/" + val
          }).then(response => {
            setBarrio(response.data);
          });
    }

    const wp_toggle = () => {
        if(whatsapp == 0) {
            setWhatsApp(1);
        }else{
            setWhatsApp(0);
        }
    }

    const update_map = (lat, lng) => {
      setLatitud(lat);
      setLongitud(lng);

      change('SideX', 'latitude', lat);
      change('SideX', 'longitude', lng);
    }

    const crearServicioX = values => {

      notification.open({
        message: 'Cargando',
        description:
          'Este proceso puede demorar unos segundos',
        icon: <Icon type="loading" style={{ color: '#4caf50' }} />,
        top: 70
      });

      axios.post(API_URL + 'api/dealer/' + cookies.get("dealer").id + '/services/store?token=' +
    store.getState().authentication.user.token, values).then(response => {
      
        notification.open({
          message: 'Operacion Exitosa',
          icon: <Icon type="loading" style={{ color: '#4caf50' }} />,
          top: 70
        });
      
        // axios({
        //   method: "get",
        //   url:
        //     API_URL + "api/dealer/" + cookies.get("dealer").id + "/services/list?token=" +
        //     store.getState().authentication.user.token
        // }).then(response => {
        //   setServiciox(response.data);
        // });

        setOpenServicio(false);
      console.log(response);
    });



      console.log(values);
    }

  const mostrar_coso = values => {
    axios({
      method: "get",
      url:
        API_URL + "api/dealer/" + cookies.get("dealer").id + "/services/show/" + values + "?token=" +
        store.getState().authentication.user.token
    }).then(response => {
      seteditar_data(response.data)
      setOpenServicioEditar(true);
    });
  }

  const edit_conse = values => {
    axios.post(API_URL + "api/dealer/" + cookies.get("dealer").id + "/services/update/" + editar_data.id + "?token=" +
    store.getState().authentication.user.token, values).then(response => {

      notification.open({
        message: 'Operacion Exitosa',
        icon: <Icon type="loading" style={{ color: '#4caf50' }} />,
        top: 70
      });
    
      // axios({
      //   method: "get",
      //   url:
      //     API_URL + "api/dealer/" + cookies.get("dealer").id + "/services/list?token=" +
      //     store.getState().authentication.user.token
      // }).then(response => {
      //   setServiciox(response.data);
      // });

      seteditar_data([])
      setOpenServicioEditar(false);
      

    });
    
  }

  const eliminarData = id => {
    axios({
      method: "delete",
      url:
        API_URL + "api/dealer/" + cookies.get("dealer").id + "/services/delete/" + id + "?token=" +
        store.getState().authentication.user.token
    }).then(response => {
      // axios({
      //   method: "get",
      //   url:
      //     API_URL + "api/dealer/" + cookies.get("dealer").id + "/services/list?token=" +
      //     store.getState().authentication.user.token
      // }).then(response => {
      //   setServiciox(response.data);
      // });
    });
  }

  const { handleSubmit, pristine, reset, submitting, except } = props

  const modalShowHideEdit = () => {
    setModalUrlEditState(!openModalUrlEditState)
  }
  
  const rowSelection = {
    onChange: (selectedRowKeys, selectedRows) => {
      console.log(`selectedRowKeys: ${selectedRowKeys}`, 'selectedRows: ', selectedRows);
    },
    getCheckboxProps: (record) => ({
      disabled: record.active === 'active',
      name: record.name,
    }),
  };
  return (
    <>
    <form onSubmit={handleSubmit}>
      

              <Card className="mb-4">
              <CardBody>
              <h4 style={{display:'inline'}}>Mi concesionaria</h4>
              <hr className="mb-2" />

      
            <Row>
              <Col sm="6">

              <Field
            name="partner"
            component={InputField}
            type="text"
            label="Socio Número"
          />

           <Field
            name="company"
            component={InputField}
            type="text"
            label="Empresa"
          />

          <Field
            name="cuit"
            component={InputField}
            type="number"
            label="CUIT"
          />


              </Col>
              <Col sm="6">

             
          <Row>
            <Col sm="6">
               <Field
            name="name"
            component={InputField}
            type="text"
            label="Nombre"
          />
            </Col>
            <Col sm="6">
            <Field
            name="last_name"
            component={InputField}
            type="text"
            label="Apellido"
          />
            </Col>
            
          </Row>
          
<Field
          name="dni_type"
          children={[
            ["CI", "CI"],
            ["DU", "DU"],
            ["LC", "LC"],
            ["LE", "LE"]
          ]}
          label="Tipo de Documento"
          component={SelectSimple}
        ></Field>
          

          <Field
            name="dni"
            component={InputField}
            type="text"
            label="Número de Documento"
          />

                
              </Col>
            </Row>
            <Row>
              <Col sm={6}>
              <Field
            name="address"
            component={InputField}
            type="text"
            label="Dirección"
          />
          

          <Field
            name="region_id"
            children={provincias}
            component={SelectSimpleParser}
            label="Provincia"
            onChange={(e) => {
                const val = e.target.value
                if(val != ''){
                   call_partido(val);
                }
            }}
          />

            <Field 
            name="region_city_id"
            children={partidos}
            component={SelectSimpleParser}
            label="Partido"
            onChange={(e) => {
                const val = e.target.value
                if(val != ''){
                   call_barrio(val);
                }
            }}
          />
          

         <Field
            name="region_barrio_id"
            children={barrios}
            component={SelectSimpleParser}
            label="Barrio"
          />

         
         <Field
            name={'validated'}
            label={'Es Socio de la CCA'}
            component='input'
            style={{display:'none'}}
            type="checkbox"
            id="validatedCheck"
        ></Field>

          <Field
            name="zip_code"
            component={InputField}
            type="text"
            label="Código Postal"
          />

          <Field
            name="country"
            component={FinalSelect}
            children={new Array("Afghanistan","Albania","Algeria","Andorra","Angola","Antarctica","Antigua and Barbuda","Argentina","Armenia","Australia","Austria","Azerbaijan","Bahamas","Bahrain","Bangladesh","Barbados","Belarus","Belgium","Belize","Benin","Bermuda","Bhutan","Bolivia","Bosnia and Herzegovina","Botswana","Brazil","Brunei","Bulgaria","Burkina Faso","Burma","Burundi","Cambodia","Cameroon","Canada","Cape Verde","Central African Republic","Chad","Chile","China","Colombia","Comoros","Congo, Democratic Republic","Congo, Republic of the","Costa Rica","Cote d'Ivoire","Croatia","Cuba","Cyprus","Czech Republic","Denmark","Djibouti","Dominica","Dominican Republic","East Timor","Ecuador","Egypt","El Salvador","Equatorial Guinea","Eritrea","Estonia","Ethiopia","Fiji","Finland","France","Gabon","Gambia","Georgia","Germany","Ghana","Greece","Greenland","Grenada","Guatemala","Guinea","Guinea-Bissau","Guyana","Haiti","Honduras","Hong Kong","Hungary","Iceland","India","Indonesia","Iran","Iraq","Ireland","Israel","Italy","Jamaica","Japan","Jordan","Kazakhstan","Kenya","Kiribati","Korea, North","Korea, South","Kuwait","Kyrgyzstan","Laos","Latvia","Lebanon","Lesotho","Liberia","Libya","Liechtenstein","Lithuania","Luxembourg","Macedonia","Madagascar","Malawi","Malaysia","Maldives","Mali","Malta","Marshall Islands","Mauritania","Mauritius","Mexico","Micronesia","Moldova","Mongolia","Morocco","Monaco","Mozambique","Namibia","Nauru","Nepal","Netherlands","New Zealand","Nicaragua","Niger","Nigeria","Norway","Oman","Pakistan","Panama","Papua New Guinea","Paraguay","Peru","Philippines","Poland","Portugal","Qatar","Romania","Russia","Rwanda","Samoa","San Marino"," Sao Tome","Saudi Arabia","Senegal","Serbia and Montenegro","Seychelles","Sierra Leone","Singapore","Slovakia","Slovenia","Solomon Islands","Somalia","South Africa","Spain","Sri Lanka","Sudan","Suriname","Swaziland","Sweden","Switzerland","Syria","Taiwan","Tajikistan","Tanzania","Thailand","Togo","Tonga","Trinidad and Tobago","Tunisia","Turkey","Turkmenistan","Uganda","Ukraine","United Arab Emirates","United Kingdom","United States","Uruguay","Uzbekistan","Vanuatu","Venezuela","Vietnam","Yemen","Zambia","Zimbabwe")}
            type="text"
            label="País"
          />

<Row>
            <Col sm="6">
            <Field
            name="latitude"
            component={InputField}
            onChange={(e) => setLatitud(e.target.value)}
            type="number"
            label="Latitud"
          />
            </Col>
            <Col sm="6">
            <Field
            name="longitude"
            component={InputField}
            onChange={(e) => setLongitud(e.target.value)}
            type="number"
            label="Longitud"
          />
            </Col>
          </Row>
              </Col>
              <Col sm={6}>
              <div style={{ height: '400px', width: '100%', paddingTop: '15px' }}>
          {
            console.log({lat: parseFloat(latitud), lng: parseFloat(longitud)})
          }

            {mapsApiLoaded && mapsapi !== null && (
              <SearchBox map={mapInstance} mapsapi={mapsapi}  onPlacesChanged={(e) => update_map(e[0].geometry.location.lat(), e[0].geometry.location.lng())} />
            )}
        <GoogleMapReact
          bootstrapURLKeys={{ key: 'AIzaSyCXVfxAdMp3HKDOYbS47S9h5wpKqyJmpeY', libraries: ['places', 'drawing']}}
          yesIWantToUseGoogleMapApiInternals
          onGoogleApiLoaded={({ map, maps }) => apiHasLoaded(map, maps)}
          defaultCenter={{lat: parseFloat(latitud), lng: parseFloat(longitud)}}
          center={{lat: parseFloat(latitud), lng: parseFloat(longitud)}}
          defaultZoom={13}
        >

          <Popover draggable={true} lat={parseFloat(latitud)} lng={parseFloat(longitud)} content={(
  <div>
    <p>{props.activedX.address}</p>
  </div>
)} title={props.activedX.name} trigger="click">
            <i class="material-icons" style={{fontSize:'40px',background: '#3b99fc',
    borderRadius: '11px',
    color: 'white'}}>directions_car</i>
          </Popover>
          
        </GoogleMapReact>
          </div>
              </Col>
            </Row>
          
          </CardBody>
              </Card>

              <Card className="mb-4">
                <CardBody>

                  <h4>Datos de contacto</h4>
                  <hr className="mb-2" />

                  <Row>
                    <Col>


      <div>

     
        <Row>
          <Col sm="6">

          <Field
            name="contact"
            component={InputField}
            type="text"
            label="Contacto"
          />
            <Field
            name="email"
            component={InputField}
            type="text"
            label="Email"
          />

<Field
            name="phone"
            component={InputField}
            type="number"
            label="Teléfono"
          />

          <Field
            name="phone2"
            component={InputField}
            type="number"
            label="Segundo Telefono"
          />


          <Field
            name="cellphone"
            component={InputField}
            type="number"
            label="Celular"
          />

        <Field
            name={'whatsapp'}
            component="input"
            type="checkbox"
            onClick={wp_toggle}
            checked={whatsapp == 0 ? false : true}
        ></Field> WhatsApp 
     
  
        
          </Col>
          <Col sm="6">
          
      


          <Field
            name="work_hours"
            component={TextareaField}
            type="text"
            label="Horarios"
          />



          

         <Field
            name="facebook"
            component={InputField}
            type="text"
            label="Facebook"
          />
          
          <Field
            name="twitter"
            component={InputField}
            type="text"
            label="Twitter"
          />

          <Field
            name="youtube"
            component={InputField}
            type="text"
            label="Youtube"
          />
          <Field
            name="instagram"
            component={InputField}
            type="text"
            label="Instagram"
          />


          </Col>
        </Row>

       
                 

        </div>


        </Col>
        </Row>
        
                </CardBody>
              </Card>
              <Card className="mb-4">
                <CardBody>
                  <div style={{display:"flex", justifyContent: "space-between", alignItems:"center", marginBottom: "20px"}}>
                    <div>
                  <h4 style={{display:'inline'}}>Mi sitio web</h4>
                    </div>
                    <div   style={{display: "flex", justifyContent: "space-around"}}>
                    {props.formValues.public === 1 &&
                      <div style={{marginRight: "10px"}}>
                      <a target="_blank" href={'//' + props.ownurl + '.nuestrosautos.cca.org.ar'}>
                        <span className="btn btn-secondary">
                          Ir a mi sitio web
                        </span>
                        </a> 
                        </div>}
                        <Button  className="btn btn-primary" onClick={()=> setModalUrlEditState(!openModalUrlEditState)}>
                        Editar URL
                    </Button>
                    </div>
                  </div>
                  <Row style={{marginTop: '10px'}}>
                  <Col sm="4" style={{marginTop: '-10px'}}>
                              <Field
                                activado={props.formValues.public == 1}
                                label="Habilitado"
                                id={'public'}
                                name={'public'}
                                key={'public'}
                                component={CheckBoxSimple}
                                type="checkbox"
                              ></Field>
                    </Col>
                    <Col sm="8">
                      <div style={{display:"flex",flexDirection:"row"}}>
                      {props.domain_loading == true ?
                      <img src="https://media.giphy.com/media/3oEjI6SIIHBdRxXI40/giphy.gif" style={{width:'80px'}}/> 
                      :
                      <p style={{margin: "0"}} >Tu URL: {`${props.ownurl === "null" || props.ownurl === null ?  "NombredetusitioWeb" : props.ownurl }.nuestrosautos.cca.org.ar`} </p> 
                      }
                      </div>
                    </Col>
                  </Row>
                </CardBody>
              </Card>
            <Card>
              <CardBody>
              <h4 style={{display:'inline'}}>Color Principal de su web</h4>
              <div style={{paddingTop: '15px'}}>
          <Field
            name="color"
            component="input"
            type="color"
            label="Color"
            class="form-control"
            style={{height:'45px'}}
          />
          </div>
          </CardBody>
              </Card>
            <br/>
              <Card>
              <CardBody>
              <h4 style={{display:'inline'}}>Contenido Institucional</h4>
          <div style={{paddingTop: '15px'}}>
          
        <Field 
            name="institutional"
            component="textarea"
            label="Institucional"
            placeholder="Contenido Institucional"
            rows={5}
            class="form-control"
            />
            </div>

        
          </CardBody>
              </Card>              
              <br/>
          <BTX disabled={submitting} className="btn btn-primary mb-4 mt-4"  type="submit" block>
            Guardar
          </BTX>
        </form>
          <Modal size="lg" open={openServicio} toggle={() => console.log('Toggle')}>
            <ModalHeader>Agregar Servicio <i style={{position:'absolute', right: '20px', top: '15px', fontSize: '25px', cursor: 'pointer'}} class="material-icons" onClick={() => setOpenServicio(false)}>clear</i>  <i style={{position:'absolute', right: '20px', top: '15px', fontSize: '25px', cursor: 'pointer'}} class="material-icons" onClick={() => setOpenServicio(false)}>clear</i></ModalHeader>
              <ModalBody>
              <CrearServicio onSubmit={crearServicioX}></CrearServicio>
              </ModalBody>
          </Modal>
          <Modal size="lg" open={openServicioEditar} toggle={console.log('.')}>
              <ModalHeader>Editar Servicio  <i style={{position:'absolute', right: '20px', top: '15px', fontSize: '25px', cursor: 'pointer'}} class="material-icons" onClick={() => setOpenServicioEditar(false)}>clear</i></ModalHeader>
            <ModalBody>

            <EditarServicio activedX={editar_data} onSubmit={edit_conse}></EditarServicio>

            </ModalBody>
            </Modal>

            <ModalUrlEdit modalShowHide={openModalUrlEditState} modalFuc={modalShowHideEdit} ownurl={props.ownurl} change_url_company={props.change_url_company} />
            
    </>
  )
}

function mapState(state, props) {
   
  const { users, authentication, vehicles, adminuser } = state;

  const { user } = authentication;

  const selector = formValueSelector('SideX')
  const formValues = getFormValues("SideX")(state) || {};


  if(props.activedX) {
    return { user, users, adminuser, initialValues: props.activedX, formValues};
  }else{
    return { user, users, adminuser, formValues};
  }
}
const actionCreators = {

};

const po = reduxForm({
form: 'SideX', 
enableReinitialize: true
})(SideX);

const pox = connect(
  mapState,
  actionCreators
)(po);

export { pox as SideX };

